import React from 'react';

import styled from 'styled-components';

import Rate from 'components/lib/Rate';

import ClickableCellValue from './ClickableCellValue';

const SmallText = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

const RatingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const RatingValue = styled.span`
  font-size: 14px;
`;

const RecentCount = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 2px;
`;

type Props = {
  reviewsAverage: number | null;
  recentReviewsCount: number;
  positiveReviewsCount: number;
  negativeReviewsCount: number;
  onClick: () => void;
};

const ReviewsCell = ({
  reviewsAverage,
  recentReviewsCount,
  positiveReviewsCount,
  negativeReviewsCount,
  onClick,
}: Props) => {
  if (typeof reviewsAverage !== 'number') {
    return <SmallText>-</SmallText>;
  }

  const rating = (
    <RatingRow>
      <Rate className="small" disabled allowHalf value={reviewsAverage} />
      <RatingValue>{reviewsAverage.toFixed(1)}</RatingValue>
    </RatingRow>
  );

  if (recentReviewsCount === 0) {
    return rating;
  }

  return (
    <ClickableCellValue onClick={onClick} dataTestId="my-communities-reviews-cell" withChevron>
      {rating}
      {positiveReviewsCount > 0 && <RecentCount>{positiveReviewsCount} positive recently</RecentCount>}
      {negativeReviewsCount > 0 && <RecentCount>{negativeReviewsCount} negative recently</RecentCount>}
    </ClickableCellValue>
  );
};

export default ReviewsCell;
